import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import moment from 'moment-timezone';
import { MDBDataTableV5, MDBIcon } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import classnames from 'classnames';
import { getUser, getUser_v2 } from '../utils/dropdownlist';
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md';
import { FaEdit } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

class OrderSummary extends React.Component {
  _isMounted = true;
  orderSummary = StorageService.getSession('orderSummary');
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      isLoading: true,
      store_id:
        this.orderSummary && this.orderSummary.store_id
          ? this.orderSummary.store_id
          : this.props.data.storeList[0].store_id,
      storeList: this.props.data.storeList,
      date:
        this.orderSummary && this.orderSummary.date
          ? this.orderSummary.date
          : moment()
              .subtract(1, 'days')
              .tz('Asia/Singapore')
              .format('YYYY-MM-DD'),
      fm_date:
        this.orderSummary && this.orderSummary.fm_date
          ? this.orderSummary.fm_date
          : moment()
              .subtract(1, 'days')
              .tz('Asia/Singapore')
              .format('YYYY-MM-DD'),
      to_date:
        this.orderSummary && this.orderSummary.to_date
          ? this.orderSummary.to_date
          : moment()
              .subtract(1, 'days')
              .tz('Asia/Singapore')
              .format('YYYY-MM-DD'),
      reportList: [],
      orderStatus:
        this.orderSummary && this.orderSummary.orderStatus
          ? this.orderSummary.orderStatus
          : this.props.data.stateList[0].name,
      stateList: this.props.data.stateList,
    };
  }

  componentDidMount() {
    if (this.orderSummary) {
      this.getReport();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
    let data = this.orderSummary ? this.orderSummary : {};
    data[name] = value;
    StorageService.setSession('orderSummary', data);
    this.orderSummary = StorageService.getSession('orderSummary');
  };

  getReport() {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      order_status: this.state.orderStatus,
    };

    axios
      .post(url + ':3003/v1/order/report/order', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            reportList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    // console.log(this.state);
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col md={3}>
            <Input
              className="ps-input-small"
              type="select"
              name="store_id"
              value={this.state.store_id}
              onChange={this.changeHandler}
            >
              {this.state.storeList.map(item => {
                return (
                  <option key={item.store_id} value={item.store_id}>
                    {item.name}
                  </option>
                );
              })}
            </Input>
          </Col>
          <Col md={3}>
            <Input
              className="ps-input-small"
              type="select"
              name="orderStatus"
              value={this.state.orderStatus}
              onChange={this.changeHandler}
            >
              {this.state.stateList.map(item => {
                return (
                  <option key={item.name} value={item.name}>
                    {item.name}
                  </option>
                );
              })}
            </Input>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Input
              className="ps-input-small"
              type="date"
              name="fm_date"
              onChange={this.changeHandler}
              value={this.state.fm_date}
            />
          </Col>
          <Col md={1}>
            <p
              style={{
                padding: '0.4rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              To
            </p>
          </Col>
          <Col md={3}>
            <Input
              className="ps-input-small"
              type="date"
              name="to_date"
              onChange={this.changeHandler}
              value={this.state.to_date}
            />
          </Col>
          <Col md={2}>
            <Button className="ps-input-small" onClick={() => this.getReport()}>
              Search
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table className="ps-table tb-col-4 ps-responsive-table">
              <Thead>
                <Tr>
                  <Th>Category</Th>
                  <Th>Product No.</Th>
                  <Th>Name</Th>
                  <Th>Quantity</Th>
                </Tr>
              </Thead>
              <Tbody>
                {this.state.reportList.length < 1 && (
                  <Tr>
                    <Td colSpan="4">
                      <div className="ps-empty-data">
                        <div className="empty-content">
                          <h4>No data to show</h4>
                        </div>
                      </div>
                    </Td>
                  </Tr>
                )}
                {this.state.reportList.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{item.category}</Td>
                      <Td>{item.product_no}</Td>
                      <Td>{item.name}</Td>
                      <Td>{item.qty}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </Col>
        </Row>
      </>
    );
  }
}

export default OrderSummary;
